import { useState } from 'react';

const faqItems = [
  {
    question: 'What is a PandabuySpreadsheet?',
    answer: 'A PandabuySpreadsheet is a curated product indexing system that organizes thousands of items into structured spreadsheets, allowing users to discover fashion products faster, compare prices across categories, and access agent-based shopping platforms efficiently. Each spreadsheet entry includes product links, price ranges, quality ratings, and category tags to streamline your shopping experience.',
  },
  {
    question: 'How often is the PandabuySpreadsheet updated?',
    answer: 'Our PandabuySpreadsheet database is updated daily with new finds, trending items, and verified product listings. We continuously monitor popular categories like shoes, streetwear, and accessories to ensure you always have access to the freshest curated content available on agent shopping platforms.',
  },
  {
    question: 'Do I need an account to use PandabuySpreadsheet?',
    answer: 'No signup or registration is required. All PandabuySpreadsheet collections are freely accessible. Simply browse categories, click through to product listings, and start discovering curated fashion finds immediately. We believe in making spreadsheet shopping as frictionless as possible.',
  },
  {
    question: 'How do I use a Pandabuy Spreadsheet for shopping?',
    answer: 'Using a Pandabuy Spreadsheet is straightforward: browse our category pages to find the type of product you are looking for, click any listing to open the product page on the agent platform, copy the product link into your preferred shopping agent, and complete your purchase. Each spreadsheet entry is organized with clear categories for intuitive navigation.',
  },
  {
    question: 'Are the products in PandabuySpreadsheet verified?',
    answer: 'Yes, our team carefully curates and verifies each PandabuySpreadsheet listing. We prioritize listings with positive feedback, clear product images, and reliable seller histories. While we strive to maintain high-quality curated lists, we always recommend reviewing individual product pages before purchasing.',
  },
];

export default function FAQSection() {
  const [openIdx, setOpenIdx] = useState<number | null>(null);

  const toggle = (idx: number) => setOpenIdx(openIdx === idx ? null : idx);

  return (
    <section className="py-20 md:py-28 bg-background-50">
      <div className="max-w-[800px] mx-auto px-6 md:px-10">
        <div className="text-center mb-14">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950">
            Frequently Asked Questions
          </h2>
          <p className="mt-3 text-foreground-600 text-base">
            Everything you need to know about PandabuySpreadsheet
          </p>
        </div>

        <div className="space-y-3">
          {faqItems.map((item, idx) => (
            <div key={idx} className="rounded-xl bg-background-100 border border-background-200/70 overflow-hidden">
              <button
                onClick={() => toggle(idx)}
                className="w-full flex items-center justify-between px-6 py-4 text-left cursor-pointer"
                aria-expanded={openIdx === idx}
              >
                <span className="text-sm md:text-base font-semibold text-foreground-900 pr-4">
                  {item.question}
                </span>
                <span className={`w-6 h-6 flex-shrink-0 flex items-center justify-center transition-transform duration-200 text-foreground-400 ${openIdx === idx ? 'rotate-45' : ''}`}>
                  <i className="ri-add-line text-lg"></i>
                </span>
              </button>
              {openIdx === idx && (
                <div className="px-6 pb-5">
                  <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                    {item.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>

      <script type="application/ld+json" dangerouslySetInnerHTML={{
        __html: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FAQPage",
          "mainEntity": faqItems.map((item) => ({
            "@type": "Question",
            "name": item.question,
            "acceptedAnswer": {
              "@type": "Answer",
              "text": item.answer,
            },
          })),
        }),
      }} />
    </section>
  );
}